<template>
  <div
    class="flex h-full min-h-0 flex-1 flex-col items-center justify-center gap-4 p-6 text-center"
    role="alert"
    data-test="load-error"
  >
    <FontAwesomeIcon
      :icon="['fas', 'triangle-exclamation']"
      class="text-4xl text-gray-400"
    />
    <p class="text-lg font-semibold capitalize-first">
      {{ $t('toasts.something_went_wrong') }}
    </p>
    <BaseButton
      data-test="retry"
      :title="$t('button.reload')"
      @click="$emit('retry')"
    />
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'

/**
 * What a page of a commission note shows when its note could not be loaded for
 * another reason than a missing or forbidden note (the user is then sent back
 * to the list): a message and a way to try again, instead of an empty page.
 */
export default {
  name: 'CommissionNoteLoadError',
  components: { BaseButton, FontAwesomeIcon },
  emits: ['retry']
}
</script>
